import ApiService from './api';

// Cars API service
class CarService {
  // Get all cars with filtering (for agents)
  static async getCars(params = {}) {
    try {
      const response = await ApiService.get('/cars', params);
      return response;
    } catch (error) {
      throw error;
    }
  }

  // Get top performing cars
  static async getTopPerformingCars(limit = 10) {
    try {
      const response = await ApiService.get('/cars/top-performing', { limit });
      return response;
    } catch (error) {
      throw error;
    }
  }

  // Get pending cars for approval
  static async getPendingCars(params = {}) {
    try {
      const response = await ApiService.get('/cars/admin/pending', params);
      return response;
    } catch (error) {
      throw error;
    }
  }

  // Get car by ID
  static async getCarById(carId) {
    try {
      const response = await ApiService.get(`/cars/${carId}`);
      return response;
    } catch (error) {
      throw error;
    }
  }

  // Approve car
  static async approveCar(carId, notes = '') {
    try {
      const response = await ApiService.post(`/cars/${carId}/approve`, { notes });
      return response;
    } catch (error) {
      throw error;
    }
  }

  // Reject car
  static async rejectCar(carId, reason, notes = '') {
    try {
      const response = await ApiService.post(`/cars/${carId}/reject`, {
        reason,
        notes
      });
      return response;
    } catch (error) {
      throw error;
    }
  }

  // Toggle featured status
  static async toggleFeatured(carId) {
    try {
      const response = await ApiService.post(`/cars/${carId}/feature`);
      return response;
    } catch (error) {
      throw error;
    }
  }

  // Get car analytics
  static async getCarAnalytics(carId, period = '30d') {
    try {
      const response = await ApiService.get(`/cars/${carId}/analytics`, {
        period
      });
      return response;
    } catch (error) {
      throw error;
    }
  }

  // Bulk car actions
  static async bulkCarActions(action, carIds, data = {}) {
    try {
      const response = await ApiService.post('/cars/bulk-actions', {
        action,
        carIds,
        ...data
      });
      return response;
    } catch (error) {
      throw error;
    }
  }

  // Get reported cars
  static async getReportedCars(params = {}) {
    try {
      const response = await ApiService.get('/cars/admin/reported', params);
      return response;
    } catch (error) {
      throw error;
    }
  }

  // Get filter options
  static async getFilterOptions() {
    try {
      const response = await ApiService.get('/cars/filter-options');
      return response;
    } catch (error) {
      throw error;
    }
  }

  // Get car statistics for dashboard
  static async getCarStats(period = '30d') {
    try {
      const response = await ApiService.get('/cars/stats', { period });
      return response;
    } catch (error) {
      throw error;
    }
  }

  // Update car status
  static async updateCarStatus(carId, status, reason = '') {
    try {
      const response = await ApiService.put(`/cars/${carId}/status`, {
        status,
        reason
      });
      return response;
    } catch (error) {
      throw error;
    }
  }

  // Delete car
  static async deleteCar(carId) {
    try {
      const response = await ApiService.delete(`/cars/${carId}`);
      return response;
    } catch (error) {
      throw error;
    }
  }

  // Get cars by category
  static async getCarsByCategory() {
    try {
      const response = await ApiService.get('/cars/category-stats');
      return response;
    } catch (error) {
      throw error;
    }
  }
}

export default CarService;